import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addEducationsAction,
    updateEducationsAction,
    deleteEducationsAction
} from '../../../redux/actions/admin/adminAction';

export const Education = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'education': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'education': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateEducation(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addEducation(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteEducation(id)
    }

    const [educationColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Education Grade", field: 'education', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])


    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.educations}
                defaultColDef={defaultColDef}
                columnDefs={educationColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Educations</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Education</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="education"
                                name="education"
                                value={inputData.education}
                                onChange={handleChange}
                                placeholder="Education"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const educations = state.admin.educations;
    return {
        educations: educations,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addEducation: (data) => dispatch(addEducationsAction(data)),
        updateEducation: (id, data) => dispatch(updateEducationsAction(id, data)),
        deleteEducation: (id) => dispatch(deleteEducationsAction(id)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Education)